/** Fixed Optic contacts shown on the CRM Post Sale Email template. */
export const POST_SALE_EMAIL_CONTACTS = {
  shippingDelivery: {
    name: 'Mike Foley',
    phone: '(732) 809-4600',
    email: 'foley@optictruckworks.com',
  },
  repairsScheduleB: {
    name: 'Cody Rodriguez',
    phone: '(732) 877-9064',
    email: 'cody@optictruckworks.com',
  },
  generalManager: {
    name: 'Anthony Carracino',
    phone: '(908) 405-9543',
    email: 'anthony@optictruckworks.com',
  },
} as const;

/** @deprecated Use {@link POST_SALE_EMAIL_CONTACTS} */
export const SHIPPING_INTRODUCTION_CONTACTS = {
  generalManager: {
    name: 'Anthony',
    fullName: POST_SALE_EMAIL_CONTACTS.generalManager.name,
    title: 'General Manager',
  },
  shippingManager: {
    name: POST_SALE_EMAIL_CONTACTS.shippingDelivery.name,
    title: 'Head of Shipping',
    phone: POST_SALE_EMAIL_CONTACTS.shippingDelivery.phone,
    email: POST_SALE_EMAIL_CONTACTS.shippingDelivery.email,
  },
} as const;
